import { useMutation } from '@tanstack/react-query'

export const mutateCopyAdData = (params) => {

    const mutation = useMutation({
        mutationKey: ['copy-ad-data-text-extraction', params],
        mutationFn: async (value) => {
            const res = await axios.post(route('api.ads_editor.copy_ad_data', { ad: route().params.ad }), params);
            return res?.data || [];
        },
        onError: async (response) => {
            console.log(response)
        }
    });

    return mutation;
}